export default ({ strapi }) => {
	// registeration phase
};
